<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
        <v-flex xs12 sm12 md12 lg12>
          <v-chip
              v-for="chip in chips" :key="chip.id"
              class="ma-2"
              color="indigo darken-3"
              outlined
              @click="openSelectedTemplate(chip)"
          >
            <v-icon left>
              {{chip.icon}}
            </v-icon>
            {{chip.title}}
          </v-chip>
        </v-flex>
      </v-layout>
    <v-dialog v-model="openEmailDialog"
              persistent
              width="500px"
    >
      <v-card v-if="selectedTemplate">
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin headline">{{selectedTemplate.title}}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="openEmailDialog = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>

          <v-text-field
              label="Subject"
              v-model="selectedTemplate.subject"
              auto-grow
              outlined
              row-height="20"
          ></v-text-field>
          <v-text-field
              label="Greetings"
              v-model="selectedTemplate.greeting"
              auto-grow
              outlined
              row-height="20"
          ></v-text-field>
          <v-textarea
              label="Body 1"
              v-model="selectedTemplate.body1"
              auto-grow
              outlined
              rows="6"
              row-height="20"
          ></v-textarea>
          <v-checkbox
              v-model="selectedTemplate.includeList"
              label="Include List"
              color="blue"
          ></v-checkbox>
          <v-text-field
              v-if="selectedTemplate.includeList"
              v-model="listItemText"
              prepend-icon="fiber_on"
              placeholder="enter list item"
              append-icon="check"
              @click:append="addListItem"
          >
          </v-text-field>
          <v-textarea
              label="Body 2"
              v-model="selectedTemplate.body2"
              auto-grow
              outlined
              rows="6"
              row-height="20"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text"
                 text outlined @click="saveEmailTemplate">Save Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  props: ['emailData'],
  data: () => ({
    chips: [
      {title: 'Standard reply', icon: 'email', id: 12345},
      {title: 'Job complete', icon: 'email', id: 123456},
      {title: 'Review us', icon: 'email', id: 1234567},
    ],
    openEmailDialog: false,
    selectedTemplate: null,
    listItemText: ''
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  // mounted () {
  //   console.log(this.emailData)
  // },
  methods: {
    addListItem () {
      let listObj = {
        created: Date.now(),
        title: this.listItemText
      }
      this.selectedTemplate.list.push(listObj)
    },
    openSelectedTemplate (chip) {
      console.log(chip)
      let selectedTemplate = {
        title: 'Standard reply',
        headerImg: '',
        includeHeaderImg: false,
        icon: 'email',
        id: 12345,
        subject: 'this is the subject',
        greeting: 'Hi ,',
        body1: '',
        includeList: false,
        list: [],
        body2: '',
        actionButton: false,
        actionButtonTitle: '',
        actionButtonLink: '',
        includeFooterImg: false,
        footerImg: '',
      }
      this.selectedTemplate = selectedTemplate
      this.openEmailDialog = true
    },
    removeTemplate (item) {
      this.chips.splice(this.chips.indexOf(item), 1)
    },
    saveEmailTemplate () {
      console.log('templateSaved')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

